import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, switchMap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthService } from './auth.service';

@Injectable()
export abstract class BaseApiService {
  protected http = inject(HttpClient);
  protected authService = inject(AuthService);
  public baseUrl = environment.serverUrl;

  /**
   * Construye parámetros HTTP dinámicos omitiendo nulos, undefined o vacíos.
   */
  protected buildParams(params?: Record<string, unknown>): HttpParams {
    let httpParams = new HttpParams();
    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== '') {
          httpParams = httpParams.set(key, value.toString());
        }
      });
    }
    return httpParams;
  }

  protected get<T>(endpoint: string, params?: Record<string, unknown>): Observable<T> {
    return this.authService.getAccessToken().pipe(
      switchMap((accessToken) =>
        this.http.get<T>(`${this.baseUrl}${endpoint}`, {
          params: this.buildParams(params),
          headers: new HttpHeaders({ Authorization: `Bearer ${accessToken}` }),
        }),
      ),
    );
  }

  protected post<T>(
    endpoint: string,
    body: unknown,
    params?: Record<string, unknown>,
  ): Observable<T> {
    return this.authService.getAccessToken().pipe(
      switchMap((accessToken) =>
        this.http.post<T>(`${this.baseUrl}${endpoint}`, body, {
          params: this.buildParams(params),
          headers: new HttpHeaders({ Authorization: `Bearer ${accessToken}` }),
        }),
      ),
    );
  }

  protected put<T>(
    endpoint: string,
    body: unknown,
    params?: Record<string, unknown>,
  ): Observable<T> {
    return this.authService.getAccessToken().pipe(
      switchMap((accessToken) =>
        this.http.put<T>(`${this.baseUrl}${endpoint}`, body, {
          params: this.buildParams(params),
          headers: new HttpHeaders({
            Authorization: `Bearer ${accessToken}`,
          }),
        }),
      ),
    );
  }
}
